export const API_URL = "https://bremskerlapi.t7e.in/api/";
// export const API_URL = "http://192.168.1.157:3334/api/";
export const GOOGLE_MAP_API_KEY = "AIzaSyAeSGLWBa0Wt0i0bT6RechZFLyU9JAyIkI";
// export const API_URL = "http://localhost:3334/api/";

export const user = JSON.parse(localStorage.getItem("user")) ?? {};
